// extracted by mini-css-extract-plugin
module.exports = {"content":"AppOpen_content__fAGO7","openApp":"AppOpen_openApp__GSqgr"};